<template>
  <nav>
    <div class="nav-inner">
      <img :src="baseUrl + logo" class="logo">
      <ul class="menu">
        <router-link to="home" class="menu-item">首页</router-link>
        <router-link to="hall" class="menu-item">办事大厅</router-link>
        <router-link to="apps" class="menu-item" v-if="isLogin">应用中心</router-link>
        <router-link to="task" class="menu-item" v-if="isLogin">任务中心</router-link>
      </ul>
      <div class="profile" v-if="isLogin">
        <div class="username">{{ userInfo.name }}</div>
        <el-dropdown trigger="hover">
          <img class="avatar" :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../../assets/avatar.jpg')"
            width="42">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="$router.push('profile')"
              v-if="userInfo.userDict != 4">个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="login" @click="login" v-else>登录</div>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="修改密码" width="500px" append-to-body class="password-dialog">
      <el-result icon="warning" title="安全提示">
        <template slot="icon">
          <i class="el-icon-lock" style="font-size: 50px"></i>
        </template>
        <template slot="subTitle">
          <div class="flex-column" style="gap:10px">
            <b>您已长时间未修改密码，为了您的账户安全，建议您更新密码。</b>
          </div>
        </template>
        <template slot="extra">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="原始密码" prop="password">
              <el-input size="medium" type="password" show-password v-model="form.password"
                placeholder="请输入原始密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input size="medium" type="password" show-password v-model="form.newPassword"
                placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input size="medium" type="password" show-password v-model="form.confirmPassword"
                placeholder="请输入确认密码"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-result>
      <span slot="footer">
        <el-button size="medium" type="primary" @click="confirm">确定</el-button>
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </nav>
</template>

<script>
import { getUserInfo, logoutApi } from '../../layout/api'
import { getConfigInfo } from '../../views/login/api'
import { updatePassword } from '../../views/profile/api'
const { jumpURL } = projectConfig
export default {
  name: 'Navigation',
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value) {
        if (value === this.form.newPassword) {
          callback()
        } else {
          callback(new Error('两次输入的密码不一致'))
        }
      } else {
        callback(new Error('确认密码不能为空'))
      }
      callback()
    }
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      isLogin: localStorage.getItem('sys_token'),
      jumpURL,
      loginType: localStorage.getItem('loginType'),
      casLoginUrl: localStorage.getItem('casLoginUrl'),
      dialogVisible: false,
      form: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        password: [{ required: true, message: '原始密码不能为空', trigger: 'change' }],
        newPassword: [{ required: true, message: '新密码不能为空', trigger: 'change' }],
        confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'change' }]
      }
    }
  },
  async created() {
    if (this.isLogin) {
      const { data } = await getUserInfo()
      this.userInfo = data
      localStorage.setItem('userInfo', JSON.stringify(data))
      if (data.initPassword) {
        this.dialogVisible = true
        const { data: { settingValue, settingDescription } } = await getConfigInfo('psd_regex')
        const regex = new RegExp(settingValue)
        this.rules.newPassword.push({
          validator: (rule, value, callback) => {
            if (!value) return callback()
            if (regex.test(value)) callback()
            else callback(new Error(settingDescription))
          },
          trigger: 'change'
        })
      }
    }
  },
  methods: {
    confirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await updatePassword(this.form)
          location.reload()
        }
      })
    },
    login() {
      if (this.loginType == 1) this.$router.push('/login')
      else window.location.href = `${this.casLoginUrl}/login`
    },
    async logout() {
      this.$confirm('确定退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.loginType == 1) {
          await logoutApi()
          localStorage.removeItem('sys_token')
          this.$router.push('/home')
          location.reload()
        } else window.location.href = `${this.casLoginUrl}/logout`
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: $mainColor;
    z-index: -1;
  }

  .nav-inner {
    width: var(--inner-width);
    height: var(--nav-height);
    margin: auto;
    display: flex;
    align-items: center;

    .logo {
      height: 70%;
    }

    .menu {
      height: 100%;
      display: flex;
      margin: 0 50px 0 80px;
      gap: 80px;

      &-item {
        padding: 0 5px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #fff;
        border-bottom: 4px solid transparent;
        font-weight: normal;
        transition: 300ms;
        white-space: nowrap;

        &:hover {
          color: #fff;
        }

        &.router-link-active {
          border-color: #fff;
          -webkit-text-stroke: .5px #fff
        }
      }
    }

    .profile {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 20px;

      .username {
        font-size: 18px;
        color: #f9fbfc;
        white-space: nowrap;
      }

      .avatar {
        border-radius: 50%;
        cursor: pointer;
      }
    }

    .login {
      margin-left: auto;
      font-size: 18px;
      font-weight: bold;
      padding: 10px 30px;
      color: #fff;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
    }
  }

}
</style>
<style lang="scss">
.password-dialog {

  .el-dialog__body {
    display: flex;
    justify-content: center;

    .el-result {
      padding: 0;
    }

    .el-input {
      width: 400px;
    }
  }
}
</style>